import type { ReceiptListItem } from '../types';
import { formatReceiptNumber } from '../types';
import { formatShortDate } from './receiptFormat';

const STATUS_LABELS = { issued: 'Emitido', void: 'Anulado' } as const;

/** Exports the receipts currently listed (already filtered client-side) to .xlsx. */
export async function exportReceiptsExcel(receipts: ReceiptListItem[], year: number): Promise<void> {
  // Loaded on demand: exceljs is large and only needed when exporting.
  const ExcelJS = (await import('exceljs')).default;
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet(`Recibos ${year}`);

  ws.columns = [
    { header: 'N°',                 key: 'number',   width: 20 },
    { header: 'Categoría',          key: 'category', width: 22 },
    { header: 'Pagador',            key: 'payer',    width: 32 },
    { header: 'C.I.',               key: 'ci',       width: 14 },
    { header: 'Fecha',              key: 'date',     width: 12 },
    { header: 'Moneda',             key: 'currency', width: 9 },
    { header: 'Total',              key: 'total',    width: 14, style: { numFmt: '#,##0.00' } },
    { header: 'Estado',             key: 'status',   width: 11 },
    { header: 'Motivo anulación',   key: 'reason',   width: 36 },
  ];
  ws.getRow(1).font = { bold: true };
  ws.views = [{ state: 'frozen', ySplit: 1 }];

  for (const r of receipts) {
    ws.addRow({
      number:   formatReceiptNumber(r.number),
      category: r.category?.name ?? '',
      payer:    r.payer_name,
      ci:       r.payer_ci ?? '',
      date:     formatShortDate(r.issued_at),
      currency: r.currency,
      total:    r.total,
      status:   STATUS_LABELS[r.status],
      reason:   r.void_reason ?? '',
    });
  }

  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const a   = document.createElement('a');
  a.href     = url;
  a.download = `recibos_${year}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
}
